export enum GDPROptionType {
  Yes = "Yes",
  No = "No",
  NotSpecified = "NotSpecified"
}
